const triggerBody = {
    //testing
    send: {
        email: "",
        triggerName: "Verify User",
        company: "NorthMart"
    },
    verify: {
        id: ""
    }
};

export default triggerBody;